export const loadFavorites = () => {
  try {
    if (typeof window === 'undefined') return {};
    const raw = localStorage.getItem('favoritesByEvent');
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
};

// Returns true when the favorites were persisted, false when localStorage is
// unavailable or the write failed (private browsing, blocked storage, quota).
export const saveFavorites = (eventId, favorites) => {
  try {
    if (typeof window === 'undefined') return false;

    const raw = localStorage.getItem('favoritesByEvent');
    const prevFavoritesByEvent = raw ? JSON.parse(raw) : {};

    let newFavoritesByEvent;

    if (favorites.length > 0) {
      newFavoritesByEvent = {
        ...prevFavoritesByEvent,
        [eventId]: favorites
      };
    } else {
      const { [eventId]: _removed, ...rest } = prevFavoritesByEvent;
      newFavoritesByEvent = rest;
    }

    localStorage.setItem('favoritesByEvent', JSON.stringify(newFavoritesByEvent));
    return true;
  } catch {
    return false;
  }
};
